export const isValidVersion = (ver) => {
    const versionRegex = /^\d+(\.\d+){1,3}$/;
    return versionRegex.test(ver);
};

export const isDuplicateVersion = (list, version, currentId = null) => {
    return list.some(item => item.version === version && (currentId === null || item.id !== currentId));
};

export const isValidUrl = (url) => {
    if (!url?.trim()) return false;
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    } catch {
        return false;
    }
};

export const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString();
};